"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showNewCard = showNewCard;
exports.showPurchase = showPurchase;
exports.show = show;
exports.PurchaseModal = exports.LoginModal = exports.AuthenticationForm = exports.PurchaseFooter = exports.UpsellSelector = exports.Owner = exports.PurchaseForm = exports.CreateAccountForm = exports.LoginForm = exports.ResetPasswordTokenForm = exports.ForgotPasswordForm = exports.ResetPasswordForm = exports.Checkbox = exports.TextField = exports.Help = exports.ErrorLabel = exports.NoOp = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireWildcard(require("promise-polyfill"));

var _carousel = babelHelpers.interopRequireDefault(require("carousel"));

var _privacy = babelHelpers.interopRequireDefault(require("modals/privacy"));

var _terms = babelHelpers.interopRequireDefault(require("modals/terms"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _stripeElements = require("stripe-elements");

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _PromotionCode = babelHelpers.interopRequireDefault(require("components/PromotionCode"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _temp2, _class7, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _temp4, _class9, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _temp5, _class11, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _temp6, _class13, _descriptor36, _descriptor37, _temp7, _class15, _descriptor38, _descriptor39, _descriptor40, _temp8, _class17, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _temp9, _class19, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _temp10, _class21, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _temp11, _class23, _descriptor57, _descriptor58, _temp12, _class25, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _temp13, _class27, _descriptor67, _descriptor68, _descriptor69, _temp14, _class29, _descriptor70, _descriptor71, _temp15, _class31, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _temp16, _class33, _class34, _temp17;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}


// FIXME
var StripePublicAPIKeyPromise = new _promisePolyfill.DelayedPromise(function (resolve, reject) {
  (0, _fetch.default)('purchase/stripe/key').then(function (data) {
    return data.json();
  }).then(resolve).catch(reject);
});

var NoOp = function NoOp() {};

exports.NoOp = NoOp;
var ErrorLabel = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ErrorLabel, _Component);

  function ErrorLabel() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ErrorLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ErrorLabel)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "value", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "detail", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "signInAction", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ErrorLabel, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.value, this.detail.signIn && ' ', this.detail.signIn && _react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "alert-link",
        onClick: this.signInAction
      }, "Sign in"));
    }
  }]);
  return ErrorLabel;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "detail", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "signInAction", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
})), _class);
exports.ErrorLabel = ErrorLabel;
var Help = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(Help, _Component2);

  function Help() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, Help);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(Help)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "help", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "helpTitle", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "notAddon", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(Help, [{
    key: "render",
    value: function render() {
      if (this.help) {
        return _react.default.createElement("a", {
          className: _classList.default.join(this.notAddon ? '' : 'input-group-addon', 'help'),
          "data-toggle": "popover",
          ref: this.setBootstrapPopover,
          title: this.helpTitle,
          role: "button",
          "data-html": "true",
          "data-trigger": "click",
          "data-placement": "right auto",
          "data-container": "body .modal.in .form-body",
          "data-content": _server.default.renderToStaticMarkup(_react.default.createElement("div", null, this.help)),
          tabIndex: -1
        }, _react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "help"
        }));
      }

      return null;
    }
  }, {
    key: "setBootstrapPopover",
    value: function setBootstrapPopover(node) {
      if (node) $(node).popover();
    }
  }]);
  return Help;
}(_react.Component), _temp2), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setBootstrapPopover", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setBootstrapPopover"), _class3.prototype), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "help", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "helpTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "notAddon", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class3);
exports.Help = Help;

function StripeField(Field) {
  var _class5, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _class6, _temp3;

  return _class5 = (_temp3 = _class6 =
  /*#__PURE__*/
  function (_Component3) {
    babelHelpers.inherits(_class5, _Component3);

    function _class5() {
      var _babelHelpers$getProt3;

      var _this3;

      babelHelpers.classCallCheck(this, _class5);

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(_class5)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
      _this3.state = {
        styleNormal: {},
        styleValid: {},
        styleInvalid: {},
        value: "empty",
        lastValue: "empty",
        padding: '0'
      };
      babelHelpers.initializerDefineProperty(_this3, "id", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "title", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "errors", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "onChange", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "valid", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "help", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      babelHelpers.initializerDefineProperty(_this3, "helpTitle", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
      return _this3;
    }

    babelHelpers.createClass(_class5, [{
      key: "inputField",
      value: function inputField(node) {
        if (node) {
          var x = window.getComputedStyle(node);
          var st = {
            color: x.color,
            fontFamily: x.fontFamily,
            fontSize: x.fontSize,
            fontSmoothing: x.fontSmoothing || x.webkitFontSmoothing,
            fontStyle: x.fontStyle,
            fontVariant: x.fontVariant,
            iconColor: x.color,
            // lineHeight: x.lineHeight,
            letterSpacing: x.letterSpacing,
            textAlign: x.textAlign,
            textDecoration: x.textDecoration,
            textShadow: x.textShadow,
            textTransform: x.textTransform
          };
          this.setState(babelHelpers.defineProperty({}, node.dataset.which, st));
        }
      }
    }, {
      key: "inputFieldChanged",
      value: function inputFieldChanged(value) {
        this.setState({
          value: value
        });
        this.onChange(value, false);
      }
    }, {
      key: "inputFieldBlur",
      value: function inputFieldBlur() {
        var _this4 = this;

        this.setState(function (_ref) {
          var value = _ref.value,
              lastValue = _ref.lastValue;

          _this4.onChange(value, true);

          return {
            lastValue: value
          };
        });
      }
    }, {
      key: "fieldChanged",
      value: function fieldChanged(event) {
        if (event.empty) {
          this.inputFieldChanged('empty');
        } else if (event.complete) {
          this.inputFieldChanged('complete');
        } else if (event.error) {
          this.inputFieldChanged('error:' + event.error.message);
        } else {
          this.inputFieldChanged('empty');
        }
      }
    }, {
      key: "fieldBlur",
      value: function fieldBlur(event) {
        this.inputFieldBlur();
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("div", {
          className: "form-group"
        }, _react.default.createElement("label", {
          htmlFor: this.id,
          className: "sr-only"
        }, this.title), _react.default.createElement("div", {
          className: _classList.default.join('input-group', this.valid ? 'valid' : null, this.valid === false ? 'invalid' : ''),
          style: {
            position: 'relative'
          }
        }, _react.default.createElement(Field, {
          onChange: this.fieldChanged,
          onBlur: this.fieldBlur,
          style: {
            base: this.state.styleNormal,
            complete: this.state.styleComplete,
            invalid: this.state.styleInvalid
          },
          placeholder: this.title,
          className: _classList.default.join('form-control', this.valid ? 'valid' : null, this.valid === false ? 'invalid' : '')
        }), _react.default.createElement(Help, {
          helpTitle: this.helpTitle,
          help: this.help
        }), this.valid !== void 0 ? _react.default.createElement("div", {
          className: _classList.default.join("input-group-addon", this.valid ? 'valid' : 'invalid')
        }, _react.default.createElement("span", {
          className: "material-icons",
          "data-icon": this.valid ? 'check' : 'error'
        })) : null, _react.default.createElement("input", {
          tabIndex: "-1",
          "data-which": "styleNormal",
          className: _classList.default.join('form-control'),
          style: {
            position: 'fixed',
            top: '-1000px',
            left: '-1000px',
            width: '100px'
          },
          ref: this.inputField
        }), _react.default.createElement("input", {
          tabIndex: "-1",
          "data-which": "styleComplete",
          className: _classList.default.join('form-control', 'valid'),
          style: {
            position: 'fixed',
            top: '-1000px',
            left: '-1000px',
            width: '100px'
          },
          ref: this.inputField
        }), _react.default.createElement("input", {
          tabIndex: "-1",
          "data-which": "styleInvalid",
          className: _classList.default.join('form-control', 'invalid'),
          style: {
            position: 'fixed',
            top: '-1000px',
            left: '-1000px',
            width: '100px'
          },
          ref: this.inputField
        })), this.errors ? _react.default.createElement(ErrorLabel, {
          value: this.errors
        }) : null);
      }
    }]);
    return _class5;
  }(_react.Component), _class6.displayName = "LoginFormStripeField(".concat(Field.displayName, ")"), _temp3), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "id", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "title", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "errors", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onChange", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return NoOp;
    }
  }), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "valid", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "help", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "helpTitle", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "inputField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "inputField"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "inputFieldChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "inputFieldChanged"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "inputFieldBlur", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "inputFieldBlur"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fieldChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fieldChanged"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "fieldBlur", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "fieldBlur"), _class5.prototype)), _class5;
}

var CardNumber = StripeField(_stripeElements.CardNumberElement);
var CardExpiry = StripeField(_stripeElements.CardExpiryElement);
var CardCVC = StripeField(_stripeElements.CardCVCElement);
var PostalCode = StripeField(_stripeElements.PostalCodeElement);
var TextField = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(TextField, _Component4);

  function TextField() {
    var _babelHelpers$getProt4;

    var _this5;

    babelHelpers.classCallCheck(this, TextField);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(TextField)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "id", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "title", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "onChange", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "formType", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "errors", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "valid", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "help", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "helpTitle", _descriptor21, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "autocomplete", _descriptor22, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      lastValue: _this5.props.value,
      value: _this5.props.value
    };
    return _this5;
  }

  babelHelpers.createClass(TextField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value != this.props.value) {
        this.setState({
          lastValue: newProps.value,
          value: newProps.value
        });
      }
    }
  }, {
    key: "inputFieldChanged",
    value: function inputFieldChanged(event) {
      this.setState({
        value: event.target.value
      });
      this.onChange(event.target.value, false, this.id);
    }
  }, {
    key: "inputFieldBlur",
    value: function inputFieldBlur() {
      var _this6 = this;

      this.setState(function (_ref2) {
        var value = _ref2.value,
            lastValue = _ref2.lastValue;

        _this6.onChange(value, true, _this6.id);

        return {
          lastValue: value
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: this.id,
        className: "sr-only"
      }, this.title), _react.default.createElement("div", {
        className: _classList.default.join("input-group", this.formType == 'textarea' ? 'textarea' : '')
      }, this.formType == "textarea" && _react.default.createElement("textarea", {
        placeholder: this.title,
        className: _classList.default.join("form-control", this.valid ? 'valid' : '', this.valid === false ? 'invalid' : ''),
        value: this.state.value,
        onChange: this.inputFieldChanged,
        onBlur: this.inputFieldBlur
      }), this.formType != "textarea" && _react.default.createElement("input", {
        type: this.formType,
        autoComplete: this.autocomplete,
        placeholder: this.title,
        name: this.id,
        id: this.id,
        className: _classList.default.join("form-control", this.valid ? 'valid' : '', this.valid === false ? 'invalid' : ''),
        defaultValue: this.state.value,
        onChange: this.inputFieldChanged,
        onBlur: this.inputFieldBlur,
        ref: this.gotInputField
      }), _react.default.createElement(Help, {
        helpTitle: this.helpTitle,
        help: this.help
      }), this.valid !== void 0 ? _react.default.createElement("div", {
        className: _classList.default.join("input-group-addon", this.valid ? 'valid' : 'invalid')
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": this.valid ? 'check' : 'error'
      })) : null), this.errors ? _react.default.createElement(ErrorLabel, {
        value: this.errors
      }) : null);
    }
  }]);
  return TextField;
}(_react.Component), _temp4), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return NoOp;
  }
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "formType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "text";
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "errors", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "valid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "help", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "helpTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "autocomplete", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "inputFieldChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "inputFieldChanged"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "inputFieldBlur", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "inputFieldBlur"), _class7.prototype)), _class7);
exports.TextField = TextField;
var Checkbox = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(Checkbox, _Component5);

  function Checkbox() {
    var _babelHelpers$getProt5;

    var _this7;

    babelHelpers.classCallCheck(this, Checkbox);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(Checkbox)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "id", _descriptor23, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "title", _descriptor24, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "onChange", _descriptor25, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "errors", _descriptor26, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "valid", _descriptor27, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "help", _descriptor28, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "helpTitle", _descriptor29, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    _this7.state = {
      value: _this7.props.value
    };
    return _this7;
  }

  babelHelpers.createClass(Checkbox, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value != this.props.value) this.setState({
        value: newProps.value
      });
    }
  }, {
    key: "inputFieldChanged",
    value: function inputFieldChanged(event) {
      this.setState({
        value: event.target.checked
      });
      this.onChange(event.target.checked, false);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        className: _classList.default.join(this.valid ? 'valid' : '', this.valid === false ? 'invalid' : ''),
        checked: this.state.value,
        onClick: this.inputFieldChanged,
        onChange: this.inputFieldChanged
      }), this.title, _react.default.createElement(Help, {
        helpTitle: this.helpTitle,
        help: this.help,
        notAddon: true
      }), this.valid !== void 0 ? _react.default.createElement("span", {
        className: _classList.default.join("material-icons", this.valid ? "valid" : "invalid"),
        "data-icon": this.valid ? 'check' : 'error'
      }) : null), this.errors ? _react.default.createElement(ErrorLabel, {
        value: this.errors
      }) : null);
    }
  }]);
  return Checkbox;
}(_react.Component), _temp5), (_descriptor23 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return NoOp;
  }
}), _descriptor26 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "errors", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "valid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "help", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "helpTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "inputFieldChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "inputFieldChanged"), _class9.prototype)), _class9);
exports.Checkbox = Checkbox;
var ResetPasswordForm = (_class11 = (_temp6 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(ResetPasswordForm, _Component6);

  function ResetPasswordForm() {
    var _babelHelpers$getProt6;

    var _this8;

    babelHelpers.classCallCheck(this, ResetPasswordForm);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this8 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt6 = babelHelpers.getPrototypeOf(ResetPasswordForm)).call.apply(_babelHelpers$getProt6, [this].concat(args)));
    _this8.state = {
      password: "",
      password_error: "",
      global_error: "",
      loading: false
    };
    babelHelpers.initializerDefineProperty(_this8, "authUser", _descriptor30, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "authToken", _descriptor31, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "targetCatalogItem", _descriptor32, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "children", _descriptor33, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "onLoggedIn", _descriptor34, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    babelHelpers.initializerDefineProperty(_this8, "onError", _descriptor35, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this8)));
    return _this8;
  }

  babelHelpers.createClass(ResetPasswordForm, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        onSubmit: this.doForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Reset Password"), _react.default.createElement("p", null, "Create a new password for your account below.")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
        value: this.state.global_error
      }) : null, _react.default.createElement(TextField, {
        autocomplete: "new-password",
        id: "password",
        title: "Your password",
        disabled: this.state.loading,
        formType: "password",
        value: this.state.password,
        onChange: this.setPassword,
        errors: this.state.password_error,
        valid: this.state.password_valid,
        helpTitle: "Password Requirements",
        help: "Password must be at least 8 characters long."
      }), _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmit()
      }, "Continue"), this.children);
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return !this.loading && this.state.password_valid;
    }
  }, {
    key: "setPassword",
    value: function setPassword(value, validate) {
      var st = {
        password: value
      };

      if (!value) {
        if (validate) {
          st.password_error = 'Please enter your new password.';
          st.password_valid = false;
        }
      } else if (value.length < 8) {
        if (validate) {
          st.password_error = 'Your password must be at least 8 characters long.';
          st.password_valid = false;
        }
      } else {
        st.password_error = '';
        st.password_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this9 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        this.setState({
          loading: true
        }, function () {
          var password = _this9.state.password;
          var authUser = _this9.authUser,
              authToken = _this9.authToken,
              targetCatalogItem = _this9.targetCatalogItem;
          (0, _fetch.default)('account/reset', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              authUser: authUser,
              authToken: authToken,
              password: password,
              targetCatalogItem: targetCatalogItem
            })
          }).then(function (result) {
            return result.json();
          }).then(function (d) {
            if (d.userId) {
              (0, _noty.showNotificationText)('Your password has been reset.');

              _this9.onLoggedIn(Object.assign({
                isNewAccount: false
              }, d));
            } else if (d.error) _this9.setState({
              loading: false,
              global_error: d.error
            });else _this9.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });
          }).catch(function (e) {
            _this9.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });

            console.error(e);
          });
        });
      }
    }
  }]);
  return ResetPasswordForm;
}(_react.Component), _temp6), (_descriptor30 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "authUser", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "authToken", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "targetCatalogItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor33 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "onLoggedIn", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor35 = babelHelpers.applyDecoratedDescriptor(_class11.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "setPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "setPassword"), _class11.prototype), babelHelpers.applyDecoratedDescriptor(_class11.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class11.prototype, "doForm"), _class11.prototype)), _class11);
exports.ResetPasswordForm = ResetPasswordForm;
var ForgotPasswordForm = (_class13 = (_temp7 =
/*#__PURE__*/
function (_Component7) {
  babelHelpers.inherits(ForgotPasswordForm, _Component7);

  function ForgotPasswordForm() {
    var _babelHelpers$getProt7;

    var _this10;

    babelHelpers.classCallCheck(this, ForgotPasswordForm);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this10 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt7 = babelHelpers.getPrototypeOf(ForgotPasswordForm)).call.apply(_babelHelpers$getProt7, [this].concat(args)));
    _this10.state = {
      username: "",
      username_error: "",
      global_error: "",
      loading: false
    };
    babelHelpers.initializerDefineProperty(_this10, "children", _descriptor36, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    babelHelpers.initializerDefineProperty(_this10, "onSuccess", _descriptor37, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this10)));
    return _this10;
  }

  babelHelpers.createClass(ForgotPasswordForm, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        onSubmit: this.doForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Forgot Password"), _react.default.createElement("p", null, "Enter your email address and we will email you instructions for resetting your password.")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
        value: this.state.global_error
      }) : null, _react.default.createElement(TextField, {
        autocomplete: "username",
        id: "email",
        disabled: this.state.loading,
        title: "Your email address",
        formType: "email",
        value: this.state.username,
        onChange: this.setUsername,
        errors: this.state.username_error,
        valid: this.state.username_valid
      }), _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmit()
      }, "Continue"), this.children);
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return !this.loading && this.state.username_valid;
    }
  }, {
    key: "setUsername",
    value: function setUsername(value, validate) {
      var st = {
        username: value
      };

      if (value.indexOf('@') == -1 || value.lastIndexOf('.') < value.indexOf('@') || value.indexOf(' ') != -1) {
        if (validate) {
          st.username_error = 'Please enter a valid email address.';
          st.username_valid = false;
        }
      } else {
        st.username_error = '';
        st.username_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this11 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        this.setState({
          loading: true
        }, function () {
          var username = _this11.state.username;
          (0, _fetch.default)('account/forgot', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username: username
            })
          }).then(function (result) {
            return _promisePolyfill.default.resolve(result).then(function (result) {
              return result.json();
            }).catch(function (e) {
              return {
                ok: true
              };
            });
          }).then(function (d) {
            if (d.ok) _this11.onSuccess({
              username: username,
              success: true,
              message: 'Password has been reset.'
            });else _this11.setState({
              loading: false,
              global_error: d.error
            });
          }).catch(function (e) {
            _this11.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });

            console.error(e);
          });
        });
      }
    }
  }]);
  return ForgotPasswordForm;
}(_react.Component), _temp7), (_descriptor36 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = babelHelpers.applyDecoratedDescriptor(_class13.prototype, "onSuccess", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), babelHelpers.applyDecoratedDescriptor(_class13.prototype, "setUsername", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class13.prototype, "setUsername"), _class13.prototype), babelHelpers.applyDecoratedDescriptor(_class13.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class13.prototype, "doForm"), _class13.prototype)), _class13);
exports.ForgotPasswordForm = ForgotPasswordForm;
var ResetPasswordTokenForm = (_class15 = (_temp8 =
/*#__PURE__*/
function (_Component8) {
  babelHelpers.inherits(ResetPasswordTokenForm, _Component8);

  function ResetPasswordTokenForm() {
    var _babelHelpers$getProt8;

    var _this12;

    babelHelpers.classCallCheck(this, ResetPasswordTokenForm);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this12 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt8 = babelHelpers.getPrototypeOf(ResetPasswordTokenForm)).call.apply(_babelHelpers$getProt8, [this].concat(args)));
    _this12.state = {
      token: "",
      token_error: "",
      global_error: "",
      loading: false
    };
    babelHelpers.initializerDefineProperty(_this12, "children", _descriptor38, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "onSuccess", _descriptor39, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    babelHelpers.initializerDefineProperty(_this12, "username", _descriptor40, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this12)));
    return _this12;
  }

  babelHelpers.createClass(ResetPasswordTokenForm, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        onSubmit: this.doForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Forgot Password"), _react.default.createElement("p", null, "A password reset token has been emailed to you. Enter it below to continue resetting your password.")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
        value: this.state.global_error
      }) : null, _react.default.createElement(TextField, {
        autocomplete: "off",
        id: "token",
        disabled: this.state.loading,
        title: "Password token",
        value: this.state.token,
        onChange: this.setToken,
        errors: this.state.token_error,
        valid: this.state.token_valid
      }), _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmit()
      }, "Continue"), this.children);
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return !this.loading && this.state.token_valid;
    }
  }, {
    key: "setToken",
    value: function setToken(value, validate) {
      var st = {
        token: value
      };

      if (!/^\d{3}$/.exec(value)) {
        if (validate) {
          st.token_error = 'Please provide a valid token.';
          st.token_valid = false;
        }
      } else {
        st.token_error = '';
        st.token_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this13 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        this.setState({
          loading: true
        }, function () {
          var token = _this13.state.token;
          var username = _this13.props.username;
          (0, _fetch.default)('account/reset-token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username: username,
              token: token
            })
          }).then(function (result) {
            return result.json();
          }).then(function (data) {
            if (data.success) {
              _this13.onSuccess(data);
            } else {
              _this13.setState({
                loading: false,
                global_error: data.error
              });
            }
          }).catch(function (e) {
            _this13.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });

            console.error(e);
          });
        });
      }
    }
  }]);
  return ResetPasswordTokenForm;
}(_react.Component), _temp8), (_descriptor38 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "onSuccess", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor40 = babelHelpers.applyDecoratedDescriptor(_class15.prototype, "username", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class15.prototype, "setToken", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class15.prototype, "setToken"), _class15.prototype), babelHelpers.applyDecoratedDescriptor(_class15.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class15.prototype, "doForm"), _class15.prototype)), _class15);
exports.ResetPasswordTokenForm = ResetPasswordTokenForm;
var LoginForm = (_class17 = (_temp9 =
/*#__PURE__*/
function (_Component9) {
  babelHelpers.inherits(LoginForm, _Component9);

  function LoginForm() {
    var _babelHelpers$getProt9;

    var _this14;

    babelHelpers.classCallCheck(this, LoginForm);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this14 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt9 = babelHelpers.getPrototypeOf(LoginForm)).call.apply(_babelHelpers$getProt9, [this].concat(args)));
    _this14.state = {
      username: "",
      password: "",
      stayLoggedIn: false,
      username_error: "",
      password_error: "",
      global_error: "",
      loading: false,
      canSignUp: null
    };
    babelHelpers.initializerDefineProperty(_this14, "children", _descriptor41, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this14)));
    babelHelpers.initializerDefineProperty(_this14, "onLoggedIn", _descriptor42, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this14)));
    babelHelpers.initializerDefineProperty(_this14, "onError", _descriptor43, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this14)));
    babelHelpers.initializerDefineProperty(_this14, "targetCatalogItem", _descriptor44, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this14)));
    babelHelpers.initializerDefineProperty(_this14, "switchForm", _descriptor45, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this14)));
    return _this14;
  }

  babelHelpers.createClass(LoginForm, [{
    key: "doSignUp",
    value: function doSignUp() {
      if (this.switchForm) this.switchForm('create');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this15 = this;

      (0, _userProfile.getSiteProps)().then(function (siteProps) {
        _this15.setState({
          canSignUp: siteProps.hasCreateAccount || false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.canSignUp === null) return null;
      return _react.default.createElement("form", {
        onSubmit: this.doForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Sign in ", this.targetCatalogItem ? " to purchase" : null), this.state.canSignUp && this.switchForm && _react.default.createElement("p", null, "Don't have an account?", " ", _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.doSignUp
      }, "Sign up"))), this.state.global_error ? _react.default.createElement(ErrorLabel, {
        value: this.state.global_error
      }) : null, _react.default.createElement(TextField, {
        autocomplete: "username",
        id: "email",
        disabled: this.state.loading,
        title: "Your email address",
        formType: "email",
        value: this.state.username,
        onChange: this.setUsername,
        errors: this.state.username_error,
        valid: this.state.username_valid
      }), _react.default.createElement(TextField, {
        autocomplete: "password",
        id: "password",
        disabled: this.state.loading,
        title: "Your password",
        formType: "password",
        value: this.state.password,
        onChange: this.setPassword,
        errors: this.state.password_error,
        valid: this.state.password_valid
      }), _react.default.createElement(Checkbox, {
        title: "Keep me signed in.",
        id: "stayLoggedIn",
        disabled: this.state.loading,
        onChange: this.setStayLoggedIn,
        value: this.state.stayLoggedIn
      }), _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmit()
      }, "Continue"), this.children);
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return !this.loading && this.state.username_valid && this.state.password_valid;
    }
  }, {
    key: "setStayLoggedIn",
    value: function setStayLoggedIn(value) {
      this.setState({
        stayLoggedIn: value
      });
    }
  }, {
    key: "setUsername",
    value: function setUsername(value, validate) {
      var st = {
        username: value
      };

      if (value.indexOf('@') == -1 || value.lastIndexOf('.') < value.indexOf('@') || value.indexOf(' ') != -1) {
        if (validate) {
          st.username_error = 'Please enter a valid email address.';
          st.username_valid = false;
        }
      } else {
        st.username_error = '';
        st.username_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "setPassword",
    value: function setPassword(value, validate) {
      var st = {
        password: value
      };

      if (!value) {
        if (validate) {
          st.password_error = 'Please enter your password.';
          st.password_valid = false;
        }
      } else {
        st.password_error = '';
        st.password_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this16 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        this.setState({
          loading: true
        }, function () {
          var _this16$state = _this16.state,
              username = _this16$state.username,
              password = _this16$state.password,
              stayLoggedIn = _this16$state.stayLoggedIn;
          var targetCatalogItem = _this16.targetCatalogItem;
          (0, _fetch.default)('account/login', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username: username,
              password: password,
              stayLoggedIn: stayLoggedIn,
              targetCatalogItem: targetCatalogItem
            })
          }).then(function (result) {
            return result.json();
          }).then(function (d) {
            if (d.userId) _this16.onLoggedIn(Object.assign({
              isNewAccount: false
            }, d));else if (d.error) _this16.setState({
              loading: false,
              global_error: d.error
            });else _this16.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });
          }).catch(function (e) {
            _this16.setState({
              loading: false,
              global_error: "Internal error. Please try again."
            });

            console.error(e);
          });
        });
      }
    }
  }]);
  return LoginForm;
}(_react.Component), _temp9), (_descriptor41 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "onLoggedIn", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor43 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor44 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "targetCatalogItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor45 = babelHelpers.applyDecoratedDescriptor(_class17.prototype, "switchForm", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "doSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "doSignUp"), _class17.prototype), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "setStayLoggedIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "setStayLoggedIn"), _class17.prototype), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "setUsername", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "setUsername"), _class17.prototype), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "setPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "setPassword"), _class17.prototype), babelHelpers.applyDecoratedDescriptor(_class17.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class17.prototype, "doForm"), _class17.prototype)), _class17);
exports.LoginForm = LoginForm;
var CreateAccountForm = (_class19 = (_temp10 =
/*#__PURE__*/
function (_Component10) {
  babelHelpers.inherits(CreateAccountForm, _Component10);

  function CreateAccountForm() {
    var _babelHelpers$getProt10;

    var _this17;

    babelHelpers.classCallCheck(this, CreateAccountForm);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this17 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt10 = babelHelpers.getPrototypeOf(CreateAccountForm)).call.apply(_babelHelpers$getProt10, [this].concat(args)));
    _this17.state = {
      name: "",
      username: "",
      password: "",
      marketingOptIn: "",
      name_error: "",
      username_error: "",
      password_error: "",
      marketingOptIn_error: "",
      global_error: "",
      loading: true,
      userProfile: null,
      siteProps: null,
      errorDetail: {}
    };
    babelHelpers.initializerDefineProperty(_this17, "children", _descriptor46, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    babelHelpers.initializerDefineProperty(_this17, "onLoggedIn", _descriptor47, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    babelHelpers.initializerDefineProperty(_this17, "switchForm", _descriptor48, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    babelHelpers.initializerDefineProperty(_this17, "onError", _descriptor49, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    babelHelpers.initializerDefineProperty(_this17, "targetCatalogItem", _descriptor50, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    babelHelpers.initializerDefineProperty(_this17, "modal", _descriptor51, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this17)));
    return _this17;
  }

  babelHelpers.createClass(CreateAccountForm, [{
    key: "doSignIn",
    value: function doSignIn() {
      if (this.switchForm) this.switchForm('login');
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this18 = this;

      (0, _userProfile.getSiteProps)().then(function (siteProps) {
        var userProfile = siteProps.userProfile;

        _this18.setState({
          loading: false,
          userProfile: userProfile,
          siteProps: siteProps,
          marketingOptIn: userProfile.system.optInDefault || false
        });

        if (_this18.props.initialState) {
          var _this18$props$initial = _this18.props.initialState,
              name = _this18$props$initial.name,
              username = _this18$props$initial.username,
              marketingOptIn = _this18$props$initial.marketingOptIn,
              authUser = _this18$props$initial.authUser,
              authToken = _this18$props$initial.authToken;

          _this18.setState({
            marketingOptIn: marketingOptIn,
            authUser: authUser,
            authToken: authToken
          });

          _this18.setName(name, false);

          _this18.setUsername(username, false);
        }
      });
    }
  }, {
    key: "gotForm",
    value: function gotForm(node) {
      if (!node || this.formNode == node) return;
      this.formNode = node;
      var firstEmpty = node.querySelector('input[type=text][value=""], input[type=password][value=""]');

      if (firstEmpty) {
        firstEmpty.focus();
      }
    }
  }, {
    key: "closeAndOpenSignIn",
    value: function closeAndOpenSignIn() {
      this.modal.hide();
      setTimeout(function () {
        show('sign-in').then(function (data) {
          var modal = data;
          modal.hide();

          if (data && data.useCustomHome && location.href.split('?').shift() == data.defaultHome) {
            if (history.pushState) {
              history.pushState({}, "", data.useCustomHome);
            }
          }

          (0, _userProfile.userProfileUpdated)().then(function (profile) {
            if (data) {
              require("event-dispatcher").default(data.isNewAccount === true ? 'account-created' : 'signed-in', profile);
            }
          });
        });
      }, 100);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        ref: this.gotForm,
        onSubmit: this.doForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Create an account", this.targetCatalogItem ? " to purchase" : null), this.switchForm ? _react.default.createElement("p", null, "Already have an account? ", _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.doSignIn
      }, "Sign in")) : null), this.state.global_error ? _react.default.createElement(ErrorLabel, {
        value: this.state.global_error,
        detail: this.state.errorDetail,
        signInAction: this.closeAndOpenSignIn
      }) : null, _react.default.createElement(TextField, {
        id: "name",
        autocomplete: "name",
        title: "Enter your full name",
        disabled: this.state.loading,
        value: this.state.name,
        onChange: this.setName,
        errors: this.state.name_error,
        valid: this.state.name_valid
      }), _react.default.createElement(TextField, {
        id: "email",
        autocomplete: "username",
        title: "Enter your email address",
        disabled: this.state.loading,
        formType: "email",
        value: this.state.username,
        onChange: this.setUsername,
        errors: this.state.username_error,
        valid: this.state.username_valid
      }), _react.default.createElement(TextField, {
        id: "password",
        autocomplete: "new-password",
        title: "Create a password",
        disabled: this.state.loading,
        formType: "password",
        value: this.state.password,
        onChange: this.setPassword,
        errors: this.state.password_error,
        valid: this.state.password_valid,
        helpTitle: "Password Requirements",
        help: "Password must be at least 8 characters long."
      }), this.state.userProfile && this.state.userProfile.system.hasMarketingOptIn ? _react.default.createElement(Checkbox, {
        id: "marketingOptIn",
        title: this.state.userProfile.system.optInText,
        disabled: this.state.loading,
        value: this.state.marketingOptIn,
        onChange: this.setMarketingOptIn,
        errors: this.state.marketingOptIn_error,
        valid: this.state.marketingOptIn_valid
      }) : null, _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmit()
      }, "Continue"), this.children);
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return !this.loading && this.state.name_valid && this.state.username_valid && this.state.password_valid;
    }
  }, {
    key: "setMarketingOptIn",
    value: function setMarketingOptIn(value) {
      var st = {
        marketingOptIn: value
      };
      this.setState(st);
    }
  }, {
    key: "setName",
    value: function setName(value, validate) {
      var st = {
        name: value
      };

      if (value.replace(/\s*/g, '') == '') {
        if (validate) {
          // st.name_error = 'Your name is required.';
          st.name_error = '';
          st.name_valid = void 0;
        }
      } else {
        st.name_error = '';
        st.name_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "setUsername",
    value: function setUsername(value, validate) {
      var st = {
        username: value
      };

      if (value.indexOf('@') == -1 || value.lastIndexOf('.') < value.indexOf('@') || value.indexOf(' ') != -1) {
        if (validate) {
          if (value) st.username_error = 'Please enter a valid email address.';else st.username_error = '';
          st.username_valid = st.username_error == '' ? void 0 : false;
        }
      } else {
        st.username_error = '';
        st.username_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "setPassword",
    value: function setPassword(value, validate) {
      var st = {
        password: value
      };

      if (!value) {
        if (validate) {
          st.password_error = ''; // Please enter your password.';

          st.password_valid = void 0;
        }
      } else if (value.length < 8) {
        if (validate) {
          st.password_error = 'Your password must be at least 8 characters long.';
          st.password_valid = false;
        }
      } else {
        st.password_error = '';
        st.password_valid = true;
      }

      this.setState(st);
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this19 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        this.setState({
          loading: true
        }, function () {
          var _this19$state = _this19.state,
              userProfile = _this19$state.userProfile,
              name = _this19$state.name,
              username = _this19$state.username,
              password = _this19$state.password;
          var marketingOptIn;

          if (userProfile.system.hasMarketingOptIn) {
            marketingOptIn = _this19.state.marketingOptIn;
          }

          var targetCatalogItem = _this19.targetCatalogItem;
          var _this19$state2 = _this19.state,
              authUser = _this19$state2.authUser,
              authToken = _this19$state2.authToken;
          var authInfo = null;

          if (authUser && authToken) {
            authInfo = {
              authUser: authUser,
              authToken: authToken
            };
          }

          (0, _fetch.default)('account/create', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Object.assign({
              name: name,
              username: username,
              password: password,
              targetCatalogItem: targetCatalogItem
            }, marketingOptIn === void 0 ? {} : {
              marketingOptIn: marketingOptIn
            }, authInfo))
          }).then(function (result) {
            return result.json();
          }).then(function (d) {
            if (d.userId) {
              _this19.onLoggedIn(Object.assign({
                isNewAccount: true
              }, d));
            } else if (d.error) {
              _this19.setState({
                loading: false,
                global_error: d.error,
                errorDetail: d
              });
            } else {
              _this19.setState({
                loading: false,
                global_error: "Internal error. Please try again.",
                errorDetail: {}
              });
            }
          }).catch(function (e) {
            _this19.setState({
              loading: false,
              global_error: "Internal error. Please try again.",
              errorDetail: {}
            });

            console.error(e);
          });
        });
      }
    }
  }]);
  return CreateAccountForm;
}(_react.Component), _temp10), (_descriptor46 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "onLoggedIn", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor48 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "switchForm", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor49 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor50 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "targetCatalogItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor51 = babelHelpers.applyDecoratedDescriptor(_class19.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "doSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "doSignIn"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "gotForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "gotForm"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "closeAndOpenSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "closeAndOpenSignIn"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "setMarketingOptIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "setMarketingOptIn"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "setName", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "setName"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "setUsername", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "setUsername"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "setPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "setPassword"), _class19.prototype), babelHelpers.applyDecoratedDescriptor(_class19.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class19.prototype, "doForm"), _class19.prototype)), _class19);
exports.CreateAccountForm = CreateAccountForm;
var PurchaseForm = (_class21 = (_temp11 =
/*#__PURE__*/
function (_Component11) {
  babelHelpers.inherits(PurchaseForm, _Component11);

  function PurchaseForm() {
    var _babelHelpers$getProt11;

    var _this20;

    babelHelpers.classCallCheck(this, PurchaseForm);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this20 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt11 = babelHelpers.getPrototypeOf(PurchaseForm)).call.apply(_babelHelpers$getProt11, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this20, "children", _descriptor52, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this20)));
    babelHelpers.initializerDefineProperty(_this20, "onSuccess", _descriptor53, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this20)));
    babelHelpers.initializerDefineProperty(_this20, "onError", _descriptor54, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this20)));
    babelHelpers.initializerDefineProperty(_this20, "purchasedItem", _descriptor55, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this20)));
    babelHelpers.initializerDefineProperty(_this20, "isNewCard", _descriptor56, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this20)));
    _this20.state = {
      key: null,
      requireAddress: false
    };
    return _this20;
  }

  babelHelpers.createClass(PurchaseForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this21 = this;

      if (!this.isNewCard && this.props.priceInfo.type == 'price' && this.props.priceInfo.price == 0) {
        return;
      }

      StripePublicAPIKeyPromise.then(function (_ref3) {
        var token = _ref3.token,
            requireAddress = _ref3.requireAddress;

        _this21.setState({
          key: token,
          requireAddress: requireAddress
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.isNewCard && this.props.priceInfo.type == 'price' && this.props.priceInfo.price == 0) {
        return _react.default.createElement(PurchaseFormInner, this.props);
      }

      if (this.state.key) {
        return _react.default.createElement(_stripeElements.StripeProvider, {
          apiKey: this.state.key
        }, _react.default.createElement(_stripeElements.Elements, {
          fonts: [{
            cssSrc: "https://fonts.googleapis.com/css?family=Oxygen:300,400,700"
          }]
        }, _react.default.createElement(PurchaseFormWrappedInner, _extends({}, this.props, {
          requireAddress: this.state.requireAddress,
          isNewCard: this.isNewCard
        }))));
      }

      return null;
    }
  }]);
  return PurchaseForm;
}(_react.Component), _temp11), (_descriptor52 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "onSuccess", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor54 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor55 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "purchasedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = babelHelpers.applyDecoratedDescriptor(_class21.prototype, "isNewCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class21);
exports.PurchaseForm = PurchaseForm;
var Owner = (_class23 = (_temp12 =
/*#__PURE__*/
function (_Component12) {
  babelHelpers.inherits(Owner, _Component12);

  function Owner() {
    var _babelHelpers$getProt12;

    var _this22;

    babelHelpers.classCallCheck(this, Owner);

    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _this22 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt12 = babelHelpers.getPrototypeOf(Owner)).call.apply(_babelHelpers$getProt12, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this22, "value", _descriptor57, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this22)));
    babelHelpers.initializerDefineProperty(_this22, "onChange", _descriptor58, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this22)));
    _this22.state = {
      value: Object.assign({
        name: "",
        line1: "",
        line2: "",
        city: "",
        state: "",
        postal_code: "",
        country: ""
      }, _this22.value),
      errors: Object.assign({
        name: "",
        line1: "",
        line2: "",
        city: "",
        state: "",
        postal_code: "",
        country: ""
      }),
      valid: Object.assign({
        name: _this22.value.name ? true : void 0,
        line1: _this22.value.line1 ? true : void 0,
        line2: true,
        city: _this22.value.city ? true : void 0,
        state: true,
        postal_code: _this22.value.postal_code ? true : void 0,
        country: _this22.value.country ? true : void 0
      })
    };
    return _this22;
  }

  babelHelpers.createClass(Owner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(TextField, {
        id: "owner_name",
        title: "Name",
        value: this.state.value.name,
        onChange: this.setField,
        valid: this.state.valid.name,
        errors: this.state.errors.name
      }), _react.default.createElement(TextField, {
        id: "owner_line1",
        title: "Address",
        value: this.state.value.line1,
        onChange: this.setField,
        valid: this.state.valid.line1,
        errors: this.state.errors.line1
      }), _react.default.createElement(TextField, {
        id: "owner_city",
        title: "City",
        value: this.state.value.city,
        onChange: this.setField,
        valid: this.state.valid.city,
        errors: this.state.errors.city
      }), _react.default.createElement(TextField, {
        id: "owner_state",
        title: "State / Province",
        value: this.state.value.state,
        onChange: this.setField,
        valid: this.state.valid.state,
        errors: this.state.errors.state
      }), _react.default.createElement(TextField, {
        id: "owner_postal_code",
        title: "ZIP / Postal Code",
        value: this.state.value.postal_code,
        onChange: this.setField,
        valid: this.state.valid.postal_code,
        errors: this.state.errors.postal_code
      }), _react.default.createElement(TextField, {
        id: "owner_country",
        title: "Country",
        value: this.state.value.country,
        onChange: this.setField,
        valid: this.state.valid.country,
        errors: this.state.errors.country
      }));
    }
  }, {
    key: "setField",
    value: function setField(value, now, id) {
      var _this23 = this;

      // var f = event.target;
      this.setState(function (st) {
        var x = {
          value: Object.assign({}, st.value, babelHelpers.defineProperty({}, id.replace(/^owner_/, ''), value)),
          errors: Object.assign({}, st.errors),
          valid: Object.assign({}, st.valid)
        };

        if (id == 'owner_state') {
          x.errors.state = "";
          x.valid.state = true;
        } else {
          var f = id.replace(/^owner_/, '');

          if (value) {
            x.errors[f] = "";
            x.valid[f] = true;
          } else {
            x.errors[f] = 'Please specify a value.';
            x.valid[f] = false;
          }
        }

        return x;
      }, function () {
        _this23.onChange(_this23.state.value, Object.keys(_this23.state.valid).filter(function (v) {
          return _this23.state.valid[v] == false;
        }).length == 0);
      });
    }
  }]);
  return Owner;
}(_react.Component), _temp12), (_descriptor57 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor58 = babelHelpers.applyDecoratedDescriptor(_class23.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class23.prototype, "setField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class23.prototype, "setField"), _class23.prototype)), _class23);
exports.Owner = Owner;
var PurchaseFormInner = (_class25 = (_temp13 =
/*#__PURE__*/
function (_Component13) {
  babelHelpers.inherits(PurchaseFormInner, _Component13);

  function PurchaseFormInner(props) {
    var _this24;

    babelHelpers.classCallCheck(this, PurchaseFormInner);
    _this24 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PurchaseFormInner).call(this, props));
    _this24.state = {
      cardNumber: "",
      expirationDate: "",
      cvc: "",
      zipCode: "",
      cardNumber_error: "",
      expirationDate_error: "",
      cvc_error: "",
      zipCode_error: "",
      global_error: "",
      loading: false,
      preserve: false,
      existingAccount: null,
      selectedCard: null,
      successInfo: null,
      owner: {},
      owner_valid: false,
      owner_error: null,
      which: 'wait',
      makeDefault: false,
      invoice: null
    };
    babelHelpers.initializerDefineProperty(_this24, "children", _descriptor59, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "onSuccess", _descriptor60, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "onError", _descriptor61, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "purchasedItem", _descriptor62, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "priceInfo", _descriptor63, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "modal", _descriptor64, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "requireAddress", _descriptor65, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));
    babelHelpers.initializerDefineProperty(_this24, "isNewCard", _descriptor66, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this24)));

    if (_this24.isNewCard || _this24.priceInfo.type != 'price') {
      _this24.state.preserve = true;
    }

    return _this24;
  }

  babelHelpers.createClass(PurchaseFormInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this25 = this;

      if (!this.isNewCard && this.priceInfo.type == 'price' && Number(this.priceInfo.price) == 0) {
        this.doFree();
        return;
      }

      (0, _fetch.default)('purchase/stripe/account').then(function (result) {
        return result.json();
      }).then(function (result) {
        if (_this25.requireAddress) {
          var x = Object.assign({}, result);
          x.sources = x.sources.filter(function (source) {
            return source.owner && source.owner.address && source.owner.address.line1;
          });
          if (x.sources.filter(function (v) {
            return v.id == x.defaultSource;
          }).length == 0) x.defaultSource = null;
          result = x;
        }

        if (_this25.isNewCard) {
          var tgt;
          if (_this25.requireAddress) tgt = 'billing';else tgt = 'card';

          _this25.setState({
            existingAccount: result,
            selectedCard: null,
            invoice: null,
            which: tgt
          });
        } else {
          (0, _fetch.default)('purchase/preview', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              productId: _this25.purchasedItem.id,
              sessionId: _this25.purchasedItem.session,
              variant: _this25.priceInfo.type,
              price: _this25.priceInfo.price,
              oneTimeDiscount: _this25.priceInfo.oneTimeDiscountSource || null,
              promoCode: _this25.priceInfo.discount ? _this25.priceInfo.discount.promoCode : null
            })
          }).then(function (result) {
            return result.json();
          }).then(function (_ref4) {
            var invoice = _ref4.invoice;
            var tgt;

            if (invoice.fromStripe || invoice.useItemPrice) {
              if (invoice.useItemPrice || invoice.fromStripe && invoice.fromStripe.amount_due > 0) {
                if (_this25.isNewCard) {
                  if (_this25.requireAddress) tgt = 'billing';else tgt = 'card';
                } else {
                  if (!_this25.requireAddress) tgt = 'card';else if (result.sources.length) tgt = 'select';else tgt = 'billing';
                }
              } else {
                tgt = 'no-billing';
              }
            } else {
              tgt = 'no-billing';
            }

            _this25.setState({
              existingAccount: result,
              selectedCard: _this25.isNewCard ? null : result.defaultSource,
              invoice: invoice,
              which: tgt
            });
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this26 = this;

      var oldPC, newPC;
      if (prevProps.priceInfo && prevProps.priceInfo.discount) oldPC = prevProps.priceInfo.discount.promoCode;
      if (this.props.priceInfo && this.props.priceInfo.discount) newPC = this.props.priceInfo.discount.promoCode;

      if (oldPC !== newPC) {
        (0, _fetch.default)('purchase/preview', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            productId: this.purchasedItem.id,
            sessionId: this.purchasedItem.session,
            variant: this.priceInfo.type,
            price: this.priceInfo.price,
            oneTimeDiscount: this.priceInfo.oneTimeDiscountSource || null,
            promoCode: this.priceInfo.discount ? this.priceInfo.discount.promoCode : null
          })
        }).then(function (data) {
          return data.json();
        }).then(function (_ref5) {
          var invoice = _ref5.invoice;

          _this26.setState({
            invoice: invoice
          });
        });
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modal.hide();

      if (this.state.successInfo) {
        if (this.priceInfo.type == 'monthlyPrice' || this.priceInfo.type == 'annualPrice') {
          if (/upgrade$/.test(location.href)) {
            history.back();
          } else {
            require('layouts/SiteLayout').default.current.navigate(document.querySelector('base').href);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this27 = this;

      if (this.state.successInfo) {
        return _react.default.createElement("div", {
          className: "purchase-success"
        }, _react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "check_circle"
        }), _react.default.createElement("h2", null, "Thank You!"), this.state.successInfo.customMessage && _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: this.state.successInfo.customMessage
          }
        }), !this.state.successInfo.customMessage && !!this.state.successInfo.orderNumber && _react.default.createElement("p", {
          className: "orderNumber"
        }, "Your order number is ", _react.default.createElement("span", null, this.state.successInfo.orderNumber)), !this.state.successInfo.customMessage && (this.state.successInfo.didEmail ? _react.default.createElement("p", null, "A printable receipt has been sent to your email account.") : _react.default.createElement("p", null, "Your order has been successfully processed.")), _react.default.createElement("div", null, _react.default.createElement("button", {
          className: "btn btn-primary",
          onClick: this.closeModal
        }, "Close")), this.children);
      }

      if (!this.isNewCard && this.priceInfo.type == 'price' && Number(this.priceInfo.price) == 0) return null;
      if (this.state.which == 'wait') return null;

      if (this.state.which == 'no-billing') {
        var which;

        if (this.state.invoice.noChange) {
          which = _react.default.createElement("p", null, _react.default.createElement("b", null, "This is your current subscription plan."), _react.default.createElement("br", null), "No changes will be made. Your next billing date is ", new Date(this.state.invoice.nextBillCycle).format('F j, Y'), ".");
        } else if (this.state.invoice.reactivate) {
          which = _react.default.createElement("p", null, _react.default.createElement("b", null, "Your plan is paid for until ", new Date(this.state.invoice.nextBillCycle).format('F j, Y'), "."), _react.default.createElement("br", null), "You will not be billed for your new plan until that date.");
        } else if (this.state.invoice.downgradeAt) {
          which = _react.default.createElement("p", null, _react.default.createElement("b", null, "Your plan is paid for until ", new Date(this.state.invoice.downgradeAt).format('F j, Y'), "."), _react.default.createElement("br", null), "You will not be billed for your new plan until that date.");
        } else if (this.state.invoice.fromStripe && this.state.invoice.fromStripe.amount_due == 0) {
          which = _react.default.createElement("p", null, _react.default.createElement("b", null, "There is no chanrge for this plan."), _react.default.createElement("br", null), "Your plan will begin immediately.");
        } else {
          which = _react.default.createElement("p", null, "Unknown, fixme");
        }

        return _react.default.createElement("form", {
          onSubmit: this.doNoBillingForm
        }, _react.default.createElement("div", {
          className: "info-success-header"
        }, which), _react.default.createElement("button", {
          className: _classList.default.join('btn', 'btn-primary', this.state.loading ? 'spinning' : ''),
          type: "submit",
          "data-spin": this.state.loading ? 'true' : null
        }, "Continue"), this.children);
      }

      var infoHdr = null;

      if (this.state.invoice && this.state.invoice.fromStripe) {
        var credit = this.state.invoice.fromStripe.lines.data.map(function (v) {
          return Math.abs(Math.min(0, v.amount));
        }).reduce(function (a, b) {
          return a + b;
        });
        credit = Math.abs(credit);

        if (credit) {
          infoHdr = _react.default.createElement("div", {
            className: "info-success-header"
          }, _react.default.createElement("p", null, _react.default.createElement("b", null, "You have $", (credit / 100).toFixed(2), " credit remaining on your current plan."), _react.default.createElement("br", null), "This amount will be deducted from your first payment for an adjusted total of $", (this.state.invoice.fromStripe.amount_due / 100).toFixed(2), "."));
        }
      }

      if (this.state.which == 'select') {
        return _react.default.createElement("form", {
          onSubmit: this.doSelectForm
        }, infoHdr, _react.default.createElement("div", {
          className: "form-header"
        }, _react.default.createElement("h2", null, "Payment Information")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
          value: this.state.global_error
        }) : null, _react.default.createElement("div", {
          className: "cardSet"
        }, this.state.existingAccount.sources.map(function (source) {
          return _react.default.createElement("button", {
            type: "button",
            key: source.id,
            className: _classList.default.join('card', _this27.state.selectedCard == source.id ? 'selected' : ''),
            "data-card": source.id,
            onClick: _this27.selectCard
          }, _react.default.createElement("span", {
            className: "card-type",
            "data-brand": source.brand
          }), _react.default.createElement("span", {
            className: "card-number"
          }, "**** ", source.last4), _react.default.createElement("span", {
            className: "card-exp"
          }, "Exp. ", source.exp_month, "/", source.exp_year));
        }), _react.default.createElement("button", {
          type: "button",
          className: _classList.default.join('card', 'new', this.state.selectedCard == null ? 'selected' : ''),
          onClick: this.selectCard
        }, _react.default.createElement("span", {
          className: "message"
        }, "Enter a new payment method"))), _react.default.createElement("button", {
          className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
          type: "submit",
          "data-spin": this.state.loading ? "true" : null
        }, this.state.selectedCard == null ? 'Continue' : 'Pay Now'), this.children);
      }

      if (this.state.which == 'billing') {
        return _react.default.createElement("form", {
          onSubmit: this.doBillingForm
        }, infoHdr, _react.default.createElement("div", {
          className: "form-header"
        }, _react.default.createElement("h2", null, "Billing Information")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
          value: this.state.global_error
        }) : null, _react.default.createElement(Owner, {
          id: "stripeOwner",
          disabled: this.state.loading,
          onChange: this.setOwner,
          value: this.state.owner
        }), _react.default.createElement("button", {
          className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
          type: "submit",
          "data-spin": this.state.loading ? "true" : null,
          disabled: !this.canSubmitBilling()
        }, "Continue"), this.isNewCard && _react.default.createElement("a", {
          onClick: this.cancel,
          href: "javascript:void(0)",
          className: "btn btn-link"
        }, "Cancel"), !this.isNewCard && this.state.existingAccount.sources.length > 0 && _react.default.createElement("a", {
          onClick: this.goToSources,
          href: "javascript:void(0)",
          className: "btn btn-link"
        }, "Back"), this.children);
      }

      if (this.state.which == 'card') {
        return _react.default.createElement("form", {
          onSubmit: this.doForm
        }, infoHdr, _react.default.createElement("div", {
          className: "form-header"
        }, _react.default.createElement("h2", null, "Payment Information")), this.state.global_error ? _react.default.createElement(ErrorLabel, {
          value: this.state.global_error
        }) : null, !this.isNewCard && !this.requireAddress && this.state.existingAccount && this.state.existingAccount.sources.length ? _react.default.createElement("div", {
          className: "cardSet"
        }, this.state.existingAccount.sources.map(function (source) {
          return _react.default.createElement("button", {
            type: "button",
            key: source.id,
            className: _classList.default.join('card', _this27.state.selectedCard == source.id ? 'selected' : ''),
            "data-card": source.id,
            onClick: _this27.selectCard
          }, _react.default.createElement("span", {
            className: "card-type",
            "data-brand": source.brand
          }), _react.default.createElement("span", {
            className: "card-number"
          }, "**** ", source.last4), _react.default.createElement("span", {
            className: "card-exp"
          }, "Exp. ", source.exp_month, "/", source.exp_year));
        }), _react.default.createElement("button", {
          type: "button",
          className: _classList.default.join('card', 'new', this.state.selectedCard == null ? 'selected' : ''),
          onClick: this.selectCard
        }, _react.default.createElement("span", {
          className: "message"
        }, "Enter a new payment method"))) : null, this.state.existingAccount && this.state.selectedCard == null ? _react.default.createElement("div", null, _react.default.createElement(CardNumber, {
          id: "stripeCardNumber",
          title: "Card Number",
          disabled: this.state.loading,
          onChange: this.setCardNumberState,
          errors: this.state.cardNumber_error,
          valid: this.state.cardNumber_valid
        }), _react.default.createElement(CardExpiry, {
          id: "stripeExpirationDate",
          title: "Expiration Date (MM / YY)",
          disabled: this.state.loading,
          onChange: this.setExpirationDateState,
          errors: this.state.expirationDate_error,
          valid: this.state.expirationDate_valid
        }), _react.default.createElement(CardCVC, {
          id: "stripeCvc",
          title: "CVC",
          helpTitle: "CVC",
          help: _react.default.createElement("p", null, "The 3 digit number on the back of your card near the signature line on most cards, or the 4 digit number above the card number on an American Express card."),
          disabled: this.state.loading,
          onChange: this.setCvcState,
          errors: this.state.cvc_error,
          valid: this.state.cvc_valid
        }), !this.requireAddress && _react.default.createElement(PostalCode, {
          id: "stripeZipCode",
          title: "ZIP / Postal Code",
          disabled: this.state.loading,
          onChange: this.setZipCodeState,
          errors: this.state.zipCode_error,
          valid: this.state.zipCode_valid
        }), !this.isNewCard && this.priceInfo.type == 'price' ? _react.default.createElement(Checkbox, {
          title: "Save my card information for future purchases.",
          id: "stripeSaveCardDetails",
          disabled: this.state.loading,
          onChange: this.setPreserveDetails,
          value: this.state.preserve
        }) : null, this.isNewCard ? _react.default.createElement(Checkbox, {
          title: "Make this my default payment method.",
          id: "stripeMakeDefault",
          disabled: this.state.loading,
          onChange: this.setMakeDefault,
          value: this.state.makeDefault
        }) : null) : null, _react.default.createElement("button", {
          className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
          type: "submit",
          "data-spin": this.state.loading ? "true" : null,
          disabled: !this.canSubmit()
        }, this.isNewCard ? 'Add Payment Method' : 'Pay Now'), this.requireAddress && _react.default.createElement("a", {
          onClick: this.goToAddress,
          href: "javascript:void(0)",
          className: "btn btn-link"
        }, "Back"), this.children);
      }
    }
  }, {
    key: "setOwner",
    value: function setOwner(owner, owner_valid) {
      this.setState({
        owner: owner,
        owner_valid: owner_valid
      });
    }
  }, {
    key: "setPreserveDetails",
    value: function setPreserveDetails(value) {
      this.setState({
        preserve: value
      });
    }
  }, {
    key: "setMakeDefault",
    value: function setMakeDefault(value) {
      this.setState({
        makeDefault: value
      });
    }
  }, {
    key: "selectCard",
    value: function selectCard(event) {
      this.setState({
        selectedCard: event.currentTarget.dataset.card || null
      });
    }
  }, {
    key: "canSubmitWithoutCard",
    value: function canSubmitWithoutCard() {
      if (this.state.loading) return false;

      if (this.state.invoice) {
        if (this.state.invoice.fromStripe && this.state.invoice.fromStripe.amount_due == 0) return true;
        if (this.state.invoice.noChange || this.state.invoice.reactivate || this.state.invoice.downgradeAt) return true;
      }

      return false;
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.state.loading) return false;

      if (this.state.invoice) {
        if (this.state.invoice.fromStripe && this.state.invoice.fromStripe.amount_due == 0) return true;
        if (this.state.invoice.noChange || this.state.invoice.reactivate || this.state.invoice.downgradeAt) return true;
      }

      return this.state.selectedCard || this.state.cardNumber_valid && this.state.cvc_valid && this.state.expirationDate_valid && (this.requireAddress ? this.state.owner_valid : this.state.zipCode_valid);
    }
  }, {
    key: "setCardNumberState",
    value: function setCardNumberState(value) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var st = {
        cardNumber: value
      };
      var valid = {
        cardNumber_valid: value == 'complete' ? true : value == 'empty' ? null : false,
        cardNumber_error: value.indexOf('error:') == 0 ? value.substring('error:'.length) : ''
      };
      if (valid.cardNumber_valid || validate) Object.assign(st, valid);
      this.setState(st);
    }
  }, {
    key: "setExpirationDateState",
    value: function setExpirationDateState(value) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var st = {
        expirationDate: value
      };
      var valid = {
        expirationDate_valid: value == 'complete' ? true : value == 'empty' ? null : false,
        expirationDate_error: value.indexOf('error:') == 0 ? value.substring('error:'.length) : ''
      };
      if (valid.expirationDate_valid || validate) Object.assign(st, valid);
      this.setState(st);
    }
  }, {
    key: "setCvcState",
    value: function setCvcState(value) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var st = {
        cvc: value
      };
      var valid = {
        cvc_valid: value == 'complete' ? true : value == 'empty' ? null : false,
        cvc_error: value.indexOf('error:') == 0 ? value.substring('error:'.length) : ''
      };
      if (valid.cvc_valid || validate) Object.assign(st, valid);
      this.setState(st);
    }
  }, {
    key: "setZipCodeState",
    value: function setZipCodeState(value) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var st = {
        zipCode: value
      };
      var valid = {
        zipCode_valid: value == 'complete' ? true : value == 'empty' ? null : false,
        zipCode_error: value.indexOf('error:') == 0 ? value.substring('error:'.length) : ''
      };
      if (valid.zipCode_valid || validate) Object.assign(st, valid);
      this.setState(st);
    }
  }, {
    key: "doFree",
    value: function doFree() {
      var _this28 = this;

      this.setState({
        loading: true
      }, function () {
        (0, _fetch.default)('purchase/free', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            productId: _this28.purchasedItem.id,
            sessionId: _this28.purchasedItem.session,
            variant: _this28.priceInfo.type,
            price: _this28.priceInfo.price,
            promoCode: _this28.priceInfo.discount ? _this28.priceInfo.discount.promoCode : null
          })
        }).then(function (result) {
          return result.json();
        }).then(function (d) {
          _this28.setState({
            successInfo: d
          });

          _this28.onSuccess(d);
        });
      });
    }
  }, {
    key: "doSelectForm",
    value: function doSelectForm(event) {
      if (this.state.selectedCard) {
        this.doForm(event);
      } else {
        event.preventDefault();
        this.setState({
          which: 'billing'
        });
      }
    }
  }, {
    key: "doNoBillingForm",
    value: function doNoBillingForm(event) {
      this.doForm(event);
    }
  }, {
    key: "doBillingForm",
    value: function doBillingForm(event) {
      event.preventDefault();
      this.setState({
        which: 'card'
      });
    }
  }, {
    key: "goToSources",
    value: function goToSources() {
      this.setState({
        which: 'select'
      });
    }
  }, {
    key: "goToAddress",
    value: function goToAddress() {
      this.setState({
        which: 'billing'
      });
    }
  }, {
    key: "canSubmitBilling",
    value: function canSubmitBilling() {
      return this.state.owner_valid;
    }
  }, {
    key: "doForm",
    value: function doForm(event) {
      var _this29 = this;

      event.preventDefault();

      if (this.canSubmit()) {
        var withoutCard = this.canSubmitWithoutCard();
        this.setState({
          loading: true
        }, function () {
          var source;

          if (withoutCard) {
            source = _promisePolyfill.default.resolve(null);
          } else {
            if (_this29.state.selectedCard) {
              source = _promisePolyfill.default.resolve({
                id: _this29.state.selectedCard
              });
            } else {
              var arg = {};

              if (_this29.requireAddress) {
                var _this29$state$owner = _this29.state.owner,
                    name = _this29$state$owner.name,
                    address = babelHelpers.objectWithoutProperties(_this29$state$owner, ["name"]);
                arg.owner = {
                  name: name,
                  address: address
                };
              }

              source = _this29.props.stripe.createSource(arg).then(function (_ref6) {
                var source = _ref6.source,
                    error = _ref6.error;
                if (source) return source;
                throw error;
              });
            }
          }

          var tgt;

          if (!withoutCard && _this29.isNewCard) {
            tgt = source.then(function (token) {
              return (0, _fetch.default)('purchase/stripe/create/card', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  token: token.id,
                  isDefault: _this29.state.makeDefault
                })
              });
            });
          } else {
            tgt = source.then(function (token) {
              return (0, _fetch.default)('purchase/stripe', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(babelHelpers.objectSpread({
                  productId: _this29.purchasedItem.id,
                  sessionId: _this29.purchasedItem.session,
                  variant: _this29.priceInfo.type,
                  price: _this29.priceInfo.price
                }, withoutCard ? {} : {
                  token: token.id
                }, {
                  oneTimeDiscount: _this29.priceInfo.oneTimeDiscountSource,
                  store: _this29.state.preserve,
                  promoCode: _this29.priceInfo.discount ? _this29.priceInfo.discount.promoCode : null
                }))
              });
            });
          }

          tgt.then(function (result) {
            return result.status == 204 ? {
              success: true
            } : result.json();
          }).then(function (d) {
            if (d.success) {
              _this29.setState({
                successInfo: d
              });

              _this29.onSuccess(d);
            } else if (d.error) {
              if (d.refreshContent) {
                (0, _noty.showNotificationText)(d.error, 'warning', 'warning');

                _this29.closeModal();

                (0, _userProfile.userProfileUpdated)();
              } else if (d.redirectTo) {
                (0, _noty.showNotificationText)(d.error, 'warning', 'warning');

                _this29.closeModal();

                if (history.pushState) {
                  history.replaceState({}, "", d.redirectTo);
                  (0, _userProfile.userProfileUpdated)();
                } else {
                  location.replace(d.redirectTo);
                }
              } else {
                _this29.setState({
                  loading: false,
                  global_error: d.error
                });
              }
            } else {
              throw {
                type: 'api_connection_error'
              };
            }
          }).catch(function (err) {
            if (babelHelpers.instanceof(err, Error)) {
              err = {
                type: 'api_connection_error'
              };
            }

            var global_error;

            switch (err.type) {
              default:
                global_error = 'Internal error. Please try again.';
                break;

              case 'invalid_request_error':
              case 'card_error':
                global_error = err.message;
                break;
            }

            _this29.setState({
              loading: false,
              global_error: global_error
            });
          });
        });
      }
    }
  }]);
  return PurchaseFormInner;
}(_react.Component), _temp13), (_descriptor59 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "onSuccess", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor61 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor62 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "purchasedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "priceInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "requireAddress", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor66 = babelHelpers.applyDecoratedDescriptor(_class25.prototype, "isNewCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "closeModal", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "closeModal"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setOwner", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setOwner"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setPreserveDetails", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setPreserveDetails"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setMakeDefault", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setMakeDefault"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "selectCard", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "selectCard"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setCardNumberState", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setCardNumberState"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setExpirationDateState", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setExpirationDateState"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setCvcState", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setCvcState"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "setZipCodeState", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "setZipCodeState"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "doFree", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "doFree"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "doSelectForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "doSelectForm"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "doNoBillingForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "doNoBillingForm"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "doBillingForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "doBillingForm"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "goToSources", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "goToSources"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "goToAddress", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "goToAddress"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "canSubmitBilling", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "canSubmitBilling"), _class25.prototype), babelHelpers.applyDecoratedDescriptor(_class25.prototype, "doForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class25.prototype, "doForm"), _class25.prototype)), _class25);
var PurchaseFormWrappedInner = (0, _stripeElements.injectStripe)(PurchaseFormInner);
var UpsellSelector = (_class27 = (_temp14 =
/*#__PURE__*/
function (_Component14) {
  babelHelpers.inherits(UpsellSelector, _Component14);

  function UpsellSelector() {
    var _babelHelpers$getProt13;

    var _this30;

    babelHelpers.classCallCheck(this, UpsellSelector);

    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }

    _this30 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt13 = babelHelpers.getPrototypeOf(UpsellSelector)).call.apply(_babelHelpers$getProt13, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this30, "upsellItems", _descriptor67, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this30)));
    babelHelpers.initializerDefineProperty(_this30, "onSelected", _descriptor68, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this30)));
    babelHelpers.initializerDefineProperty(_this30, "isUpsell", _descriptor69, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this30)));
    return _this30;
  }

  babelHelpers.createClass(UpsellSelector, [{
    key: "hasUpsell",
    value: function hasUpsell() {
      if (this.upsellItems.filter(function (v) {
        return v.model == 'subscription';
      }).length) return true;
      var items = this.upsellItems.map(function (item) {
        return item.id;
      });

      for (var i = 1; i < items.length; i++) {
        if (items[i] != items[0]) return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this31 = this;

      return _react.default.createElement("div", {
        className: "upsell-content"
      }, _react.default.createElement("h1", null, this.isUpsell ? 'Purchasing Options' : 'Select a Session'), _react.default.createElement(_carousel.default, {
        listClassName: "card-container card-grid"
      }, this.upsellItems.map(function (item) {
        return _react.default.createElement(_react.default.Fragment, {
          key: item.id
        }, _react.default.createElement(require(item.tile.child_type).default, Object.assign(item.tile, {
          buyButtonAction: _this31.clickHandler
        })));
      })));
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(event) {
      var button = event.target;
      var item = this.upsellItems.filter(function (item) {
        return item.id == button.dataset.target && item.session == button.dataset.session;
      })[0];
      var price = item.pricingOptions.filter(function (item) {
        return item.type == button.dataset.price;
      })[0];
      this.onSelected(item, price);
      event.preventDefault();
      return false;
    }
  }, {
    key: "upsellContainerElement",
    value: function upsellContainerElement(node) {
      var _this32 = this;

      if (this.carousel) {
        this.carouselNode.querySelectorAll('.buy-button').forEach(function (button) {
          button.removeEventListener('click', _this32.clickHandler);
        });
        this.carousel.remove();
        this.carousel = null;
      }

      if (node) {
        this.carousel = _carousel.default.setup(node);
        this.carouselNode = node;
        node.querySelectorAll('.buy-button').forEach(function (button) {
          button.addEventListener('click', _this32.clickHandler);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this33 = this;

      if (this.carousel) {
        this.carouselNode.querySelectorAll('.buy-button').forEach(function (button) {
          button.removeEventListener('click', _this33.clickHandler);
        });
        this.carousel.remove();
        this.carousel = null;
      }
    }
  }]);
  return UpsellSelector;
}(_react.Component), _temp14), (_descriptor67 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "upsellItems", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor69 = babelHelpers.applyDecoratedDescriptor(_class27.prototype, "isUpsell", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.hasUpsell();
  }
}), babelHelpers.applyDecoratedDescriptor(_class27.prototype, "clickHandler", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class27.prototype, "clickHandler"), _class27.prototype), babelHelpers.applyDecoratedDescriptor(_class27.prototype, "upsellContainerElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class27.prototype, "upsellContainerElement"), _class27.prototype)), _class27);
exports.UpsellSelector = UpsellSelector;
var PurchaseFooter = (_class29 = (_temp15 =
/*#__PURE__*/
function (_Component15) {
  babelHelpers.inherits(PurchaseFooter, _Component15);

  function PurchaseFooter() {
    var _babelHelpers$getProt14;

    var _this34;

    babelHelpers.classCallCheck(this, PurchaseFooter);

    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }

    _this34 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt14 = babelHelpers.getPrototypeOf(PurchaseFooter)).call.apply(_babelHelpers$getProt14, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this34, "item", _descriptor70, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this34)));
    babelHelpers.initializerDefineProperty(_this34, "isNewCard", _descriptor71, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this34)));
    return _this34;
  }

  babelHelpers.createClass(PurchaseFooter, [{
    key: "render",
    value: function render() {
      if (this.isNewCard || this.item) {
        if (!this.isNewCard && this.item.pricingOptions.length == 1 && Number(this.item.pricingOptions[0].price) == 0) {
          return null;
        }

        return _react.default.createElement("div", {
          className: "purchaseFooter"
        }, _react.default.createElement("div", {
          className: "stripeText"
        }, _react.default.createElement("i", {
          className: "lockIcon material-icons",
          "data-icon": "lock_outline"
        }), _react.default.createElement("div", {
          className: "stripeBody"
        }, _react.default.createElement("b", null, this.isNewCard ? 'Secure' : 'Secure Checkout')), _react.default.createElement("div", {
          className: "icons"
        }, _react.default.createElement("span", {
          className: "masterCard"
        }), _react.default.createElement("span", {
          className: "visa"
        }), _react.default.createElement("span", {
          className: "amex"
        }), _react.default.createElement("span", {
          className: "discover"
        }))));
      }

      return null;
    }
  }]);
  return PurchaseFooter;
}(_react.Component), _temp15), (_descriptor70 = babelHelpers.applyDecoratedDescriptor(_class29.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = babelHelpers.applyDecoratedDescriptor(_class29.prototype, "isNewCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class29);
exports.PurchaseFooter = PurchaseFooter;
var AuthenticationForm = (_class31 = (_temp16 =
/*#__PURE__*/
function (_Component16) {
  babelHelpers.inherits(AuthenticationForm, _Component16);

  function AuthenticationForm() {
    var _babelHelpers$getProt15;

    var _this35;

    babelHelpers.classCallCheck(this, AuthenticationForm);

    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }

    _this35 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt15 = babelHelpers.getPrototypeOf(AuthenticationForm)).call.apply(_babelHelpers$getProt15, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this35, "defaultPage", _descriptor72, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "children", _descriptor73, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "onLoggedIn", _descriptor74, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "onError", _descriptor75, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "onPurchaseComplete", _descriptor76, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "onSelectedItem", _descriptor77, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "purchasedItem", _descriptor78, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "priceInfo", _descriptor79, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "upsellItems", _descriptor80, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    babelHelpers.initializerDefineProperty(_this35, "modal", _descriptor81, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this35)));
    _this35.state = {
      page: _this35.defaultPage,
      canCreateAccount: null,
      loginArgs: []
    };
    return _this35;
  }

  babelHelpers.createClass(AuthenticationForm, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (newProps.defaultPage != this.defaultPage) {
        this.setState({
          page: newProps.defaultPage
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this36 = this;

      (0, _userProfile.getSiteProps)().then(function (siteProps) {
        _this36.setState({
          canCreateAccount: siteProps.hasCreateAccount,
          siteProps: siteProps
        });
      });
    }
  }, {
    key: "didResetPassword",
    value: function didResetPassword(info) {
      var username = info.username;
      this.setState({
        page: 'reset-token',
        username: username
      });
    }
  }, {
    key: "doResetPassword",
    value: function doResetPassword(result) {
      this.setState({
        page: 'reset',
        resetInfo: result
      });
    }
  }, {
    key: "onResetPassword",
    value: function onResetPassword(result) {}
  }, {
    key: "finished",
    value: function finished() {
      this.onLoggedIn.apply(this, babelHelpers.toConsumableArray(this.state.loginArgs));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.canCreateAccount === null) return null;

      if (this.state.page == 'upsell') {
        return _react.default.createElement(UpsellSelector, {
          onSelected: this.onSelectedItem,
          upsellItems: this.upsellItems
        });
      }

      if (this.state.page == 'purchase' || this.state.page == 'new-card') {
        return _react.default.createElement(PurchaseForm, {
          modal: this.modal,
          onSuccess: this.onPurchaseComplete,
          onError: this.onError,
          isNewCard: this.state.page == 'new-card',
          purchasedItem: this.purchasedItem,
          priceInfo: this.priceInfo
        }, this.children, _react.default.createElement("footer", null, _react.default.createElement(PurchaseFooter, {
          item: this.state.page == 'new-card' ? null : this.purchasedItem || this.upsellItems[0],
          isNewCard: this.state.page == 'new-card'
        })));
      }

      if (this.state.page == 'create') {
        return _react.default.createElement(CreateAccountForm, {
          switchForm: this.goToPage,
          targetCatalogItem: this.purchasedItem ? this.purchasedItem.id : null,
          onLoggedIn: this.handleLoggedIn,
          onError: this.onError,
          initialState: this.props.resetInfo ? this.props.resetInfo.initialProps : null,
          modal: this.modal
        }, this.children || _react.default.createElement("header", {
          className: "loginHeader"
        }), _react.default.createElement("footer", null, _react.default.createElement("p", null, "By clicking \u201CContinue\u201D you agree to our", this.state.siteProps.mode.TermsOfUse != 'None' ? _react.default.createElement("span", null, " ", _react.default.createElement("a", {
          href: this.state.siteProps.legalNotices.TermsOfUse.link,
          target: this.state.siteProps.legalNotices.TermsOfUse.newWindow ? "_blank" : "_self",
          "data-notice": "TermsOfUse",
          onClick: this.showLegalNotice
        }, "Terms of Use")) : null, this.state.siteProps.mode.TermsOfUse != 'None' && this.state.siteProps.mode.PrivacyPolicy != 'None' ? " and " : null, this.state.siteProps.mode.PrivacyPolicy != 'None' ? _react.default.createElement("span", null, " ", _react.default.createElement("a", {
          href: this.state.siteProps.legalNotices.PrivacyPolicy.link,
          target: this.state.siteProps.legalNotices.PrivacyPolicy.newWindow ? "_blank" : "_self",
          "data-notice": "PrivacyPolicy",
          onClick: this.showLegalNotice
        }, "Privacy Policy")) : null), _react.default.createElement(PurchaseFooter, {
          item: this.purchasedItem || this.upsellItems[0]
        })));
      }

      if (this.state.page == 'reset-token') {
        return _react.default.createElement(ResetPasswordTokenForm, {
          onSuccess: this.doResetPassword,
          onError: this.onError,
          username: this.state.username
        }, this.children || _react.default.createElement("header", {
          className: "loginHeader"
        }), _react.default.createElement("footer", null, _react.default.createElement("p", null, _react.default.createElement("a", {
          onClick: this.goLogin,
          href: "javascript:void(0)"
        }, "Sign in"), this.state.canCreateAccount && _react.default.createElement("span", null, "\u2022 ", _react.default.createElement("a", {
          onClick: this.goSignUp,
          href: "javascript:void(0)"
        }, "Create an account"))), _react.default.createElement(PurchaseFooter, {
          item: this.purchasedItem || this.upsellItems[0]
        })));
      }

      if (this.state.page == 'forgot') {
        return _react.default.createElement(ForgotPasswordForm, {
          onSuccess: this.didResetPassword,
          onError: this.onError
        }, this.children || _react.default.createElement("header", {
          className: "loginHeader"
        }), _react.default.createElement("footer", null, _react.default.createElement("p", null, _react.default.createElement("a", {
          onClick: this.goLogin,
          href: "javascript:void(0)"
        }, "Sign in"), this.state.canCreateAccount && _react.default.createElement("span", null, "\u2022 ", _react.default.createElement("a", {
          onClick: this.goSignUp,
          href: "javascript:void(0)"
        }, "Create an account"))), _react.default.createElement(PurchaseFooter, {
          item: this.purchasedItem || this.upsellItems[0]
        })));
      }

      if (this.state.page == 'reset') {
        return _react.default.createElement(ResetPasswordForm, _extends({}, this.state.resetInfo ? this.state.resetInfo : this.props.resetInfo, {
          targetCatalogItem: this.purchasedItem ? this.purchasedItem.id : null,
          onLoggedIn: this.handleLoggedIn,
          onError: this.onError
        }), this.children || _react.default.createElement("header", {
          className: "loginHeader"
        }), _react.default.createElement("footer", null, _react.default.createElement("p", null, _react.default.createElement("a", {
          onClick: this.goLogin,
          href: "javascript:void(0)"
        }, "Sign in"), this.state.canCreateAccount && _react.default.createElement("span", null, "\u2022 ", _react.default.createElement("a", {
          onClick: this.goSignUp,
          href: "javascript:void(0)"
        }, "Create an account"))), _react.default.createElement(PurchaseFooter, {
          item: this.purchasedItem || this.upsellItems[0]
        })));
      }

      return _react.default.createElement(LoginForm, {
        switchForm: this.goToPage,
        targetCatalogItem: this.purchasedItem ? this.purchasedItem.id : null,
        onLoggedIn: this.handleLoggedIn,
        onError: this.onError
      }, this.children || _react.default.createElement("header", {
        className: "loginHeader"
      }), _react.default.createElement("footer", null, _react.default.createElement("p", null, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.goForgot
      }, "Forgot password?")), _react.default.createElement(PurchaseFooter, {
        item: this.purchasedItem || this.upsellItems[0]
      })));
    }
  }, {
    key: "goToPage",
    value: function goToPage(page) {
      this.setState({
        page: page
      });
    }
  }, {
    key: "goForgot",
    value: function goForgot() {
      this.setState({
        page: 'forgot'
      });
    }
  }, {
    key: "goLogin",
    value: function goLogin() {
      this.setState({
        page: 'login'
      });
    }
  }, {
    key: "goSignUp",
    value: function goSignUp() {
      this.setState({
        page: 'create'
      });
    }
  }, {
    key: "handleLoggedIn",
    value: function handleLoggedIn() {
      this.onLoggedIn.apply(this, arguments);
    }
  }, {
    key: "showLegalNotice",
    value: function showLegalNotice(event) {
      var which = event.target.dataset.notice;

      if (this.state.siteProps.mode[which] == 'Inline') {
        event.preventDefault();

        switch (which) {
          case 'TermsOfUse':
            _terms.default.show();

            break;

          case 'PrivacyPolicy':
            _privacy.default.show();

            break;
        }
      }
    }
  }]);
  return AuthenticationForm;
}(_react.Component), _temp16), (_descriptor72 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "defaultPage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "login";
  }
}), _descriptor73 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor74 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "onLoggedIn", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return location.reload();
    };
  }
}), _descriptor75 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "onError", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor76 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "onPurchaseComplete", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor77 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "onSelectedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {
      return false;
    };
  }
}), _descriptor78 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "purchasedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor79 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "priceInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor80 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "upsellItems", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor81 = babelHelpers.applyDecoratedDescriptor(_class31.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "didResetPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "didResetPassword"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "doResetPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "doResetPassword"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "onResetPassword", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "onResetPassword"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "finished", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "finished"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "goToPage", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "goToPage"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "goForgot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "goForgot"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "goLogin", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "goLogin"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "goSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "goSignUp"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "handleLoggedIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "handleLoggedIn"), _class31.prototype), babelHelpers.applyDecoratedDescriptor(_class31.prototype, "showLegalNotice", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class31.prototype, "showLegalNotice"), _class31.prototype)), _class31);
exports.AuthenticationForm = AuthenticationForm;

var LoginModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(LoginModal, _Modal);

  function LoginModal() {
    var _this37;

    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'login';
    var resolve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return location.reload();
    };
    var reject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return false;
    };
    babelHelpers.classCallCheck(this, LoginModal);
    _this37 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(LoginModal).call(this, 'login-form'));
    _this37.innerWrapper = false;
    _this37.hasModalTitleElement = false;
    _this37._waitForUpdated = false;
    _this37.defaultPage = page;
    _this37.resolve = resolve;
    _this37.reject = reject;
    return _this37;
  }

  babelHelpers.createClass(LoginModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this38 = this;

      var AuthenticationForm = require("components/LoginForm").AuthenticationForm;

      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        args[_key16] = arguments[_key16];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(LoginModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(AuthenticationForm, {
          modal: _this38,
          defaultPage: _this38.defaultPage,
          resetInfo: _this38.resetInfo,
          onLoggedIn: _this38.resolve,
          onError: _this38.reject
        }), element.querySelector('.form-body'));

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "waitToHide",
    value: function waitToHide() {
      this._waitForUpdated = true;
    }
  }, {
    key: "hideNow",
    value: function hideNow() {
      this._waitForUpdated = false;
      return this.hide();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this39 = this;

      return new _promisePolyfill.default(function (resolve) {
        if (_this39._waitForUpdated) {
          $(document).off('sitePropsUpdated.loginModal').on('sitePropsUpdated.loginModal', function () {
            $(document).off('sitePropsUpdated.loginModal');
            babelHelpers.get(babelHelpers.getPrototypeOf(LoginModal.prototype), "hide", _this39).call(_this39);
            resolve(true);
          });
        } else {
          babelHelpers.get(babelHelpers.getPrototypeOf(LoginModal.prototype), "hide", _this39).call(_this39);
          resolve(true);
        }
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body unscaled'></div>\n\t\t";
    }
  }]);
  return LoginModal;
}(_base.default);

exports.LoginModal = LoginModal;
var PurchaseModal = (_class33 = (_temp17 = _class34 =
/*#__PURE__*/
function (_Modal2) {
  babelHelpers.inherits(PurchaseModal, _Modal2);

  function PurchaseModal(upsellItems) {
    var _this40;

    var selectedIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;
    var resolve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return location.reload();
    };
    var reject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return false;
    };
    babelHelpers.classCallCheck(this, PurchaseModal);
    _this40 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PurchaseModal).call(this, 'login-form'));
    _this40.innerWrapper = false;
    _this40.hasModalTitleElement = false;

    if (upsellItems === PurchaseModal.NewCardForm) {
      _this40.isNewCard = true;
    } else {
      _this40.upsellItems = upsellItems;
      _this40.selectedIndex = selectedIndex;

      if (_this40.upsellItems.length == 1 && _this40.upsellItems[0].pricingOptions.length == 1) {
        _this40.purchasedItem = upsellItems[0];
        _this40.priceInfo = upsellItems[0].pricingOptions[0];
      }
    }

    _this40.resolve = resolve;
    _this40.reject = reject;
    return _this40;
  }

  babelHelpers.createClass(PurchaseModal, [{
    key: "showForm",
    value: function showForm() {
      var element = this.element;
      var E = element.querySelector('.form-body');

      if (!this.isNewCard) {
        if (!(this.purchasedItem && this.priceInfo)) E.className = 'form-body upsell-form unscaled';else E.className = 'form-body unscaled';
      } else {
        E.className = 'form-body unscaled';
      }

      var AuthenticationForm = require("components/LoginForm").AuthenticationForm;

      _reactDom.default.render(_react.default.createElement(AuthenticationForm, {
        defaultPage: this.defaultPage,
        upsellItems: this.upsellItems,
        purchasedItem: this.purchasedItem,
        priceInfo: this.priceInfo,
        resetInfo: null,
        onLoggedIn: this.userLoggedIn,
        onError: this.onError,
        onSelectedItem: this.selectedItem,
        onPurchaseComplete: this.resolve,
        modal: this
      }, this.purchasedItem ? _react.default.createElement("header", {
        className: "productHeader",
        "data-item-type": this.purchasedItem.type,
        style: {
          backgroundImage: "url(".concat(this.purchasedItem.image, ")")
        }
      }, _react.default.createElement("h1", null, this.purchasedItem.title), this.purchasedItem.discount && this.purchasedItem.discount.basePrice != '$0' && _react.default.createElement("div", {
        className: "discount"
      }, _react.default.createElement("span", {
        className: "basePrice"
      }, this.purchasedItem.discount.basePrice), ' - ', "You save ", this.purchasedItem.discount.percentOff, "%"), !!Number(this.priceInfo.price) ? _react.default.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: this.priceInfo.priceText || this.priceInfo.promoText
        }
      }) : _react.default.createElement("p", null, "Free"), this.purchasedItem && !this.priceInfo.oneTimeDiscountSource && this.purchasedItem.buttonIsPurchase && (this.priceInfo.discount && this.priceInfo.discount.promoCode || !!Number(this.priceInfo.price)) && _react.default.createElement("div", {
        className: "promoCodeButton"
      }, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.doPromoCode
      }, !(this.purchasedItem.usedPromoCode || this.priceInfo.usedPromoCode) ? 'Have a discount code?' : 'Remove discount code'))) : null), element.querySelector('.form-body'));
    }
  }, {
    key: "doPromoCode",
    value: function doPromoCode() {
      var _this41 = this;

      if (!this.purchasedItem.usedPromoCode && !this.priceInfo.usedPromoCode) {
        var pcm = new _PromotionCode.default(this.purchasedItem.id, this.refreshPurchase);
        pcm.show();
      } else {
        (0, _fetch.default)("data/promo-code/remove", {
          method: 'POST',
          headers: {
            'Content-type': 'application/json'
          },
          body: '{}'
        }).then(function () {
          (0, _noty.showNotificationText)('Your discount code has been removed.');

          _this41.refreshPurchase();

          (0, _userProfile.userProfileUpdated)();
        });
      }
    }
  }, {
    key: "refreshPurchase",
    value: function refreshPurchase() {
      var _this42 = this;

      var link = this.purchasedItem.buttonLink + '?purchaseInfo=1';
      if (this.purchasedItem.oneTimeDiscountSource) link += '&specialOfferBlock=' + this.purchasedItem.oneTimeDiscountSource;
      return (0, _fetch.default)(link).then(function (data) {
        return data.text();
      }).then(function (data) {
        return Function('', 'return ' + data).call(null);
      }).then(function (data) {
        var itemsToDisplay = data.itemsToDisplay;
        var newPurchasedItem, newPriceInfo;

        if (_this42.selectedIndex !== void 0) {
          var item = Object.assign({}, itemsToDisplay[0]);
          item.pricingOptions = [item.pricingOptions[_this42.selectedIndex]];
          itemsToDisplay = [item];
          newPurchasedItem = item;
          newPriceInfo = item.pricingOptions[0];
        } else {
          for (var i = 0; i < _this42.upsellItems.length; i++) {
            if (_this42.upsellItems[i] === _this42.purchasedItem) {
              newPurchasedItem = itemsToDisplay[i];
            }
          }

          if (newPurchasedItem) {
            for (var i = 0; i < _this42.purchasedItem.pricingOptions.length; i++) {
              if (_this42.purchasedItem.pricingOptions[i] === _this42.priceInfo) {
                newPriceInfo = newPurchasedItem.pricingOptions[i];
              }
            }
          }
        }

        _this42.upsellItems = itemsToDisplay;
        _this42.purchasedItem = newPurchasedItem;
        _this42.priceInfo = newPriceInfo;

        _this42.showForm();
      });
    }
  }, {
    key: "selectedItem",
    value: function selectedItem(item, info) {
      this.purchasedItem = item;
      this.priceInfo = info;
      this.showForm();
    }
  }, {
    key: "userLoggedIn",
    value: function userLoggedIn(_ref7) {
      var _this43 = this;

      var userId = _ref7.userId,
          itemAccessGranted = _ref7.itemAccessGranted;

      if (itemAccessGranted) {
        location.reload();
        return;
      }

      (0, _userProfile.userProfileUpdated)().then(function (profile) {
        _this43.profile = profile;
        _this43.isGuest = _this43.profile.guest || false;

        _this43.showForm();
      });
    }
  }, {
    key: "onError",
    value: function onError() {}
  }, {
    key: "show",
    value: function show() {
      var _this44 = this;

      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        args[_key17] = arguments[_key17];
      }

      return (0, _userProfile.getSiteProps)().then(function (siteProps) {
        var _babelHelpers$get2;

        var userProfile = siteProps.userProfile,
            hasCreateAccount = siteProps.hasCreateAccount;
        var _userProfile$guest = userProfile.guest,
            isGuest = _userProfile$guest === void 0 ? false : _userProfile$guest;
        Object.assign(_this44, {
          isGuest: isGuest,
          initialStateWasGuest: isGuest,
          profile: userProfile,
          hasCreateAccount: hasCreateAccount
        });
        return (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(PurchaseModal.prototype), "show", _this44)).call.apply(_babelHelpers$get2, [_this44].concat(args));
      }).then(function (element) {
        _this44.showForm();

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body unscaled'></div>\n\t\t";
    }
  }, {
    key: "defaultPage",
    get: function get() {
      if (this.isNewCard) return 'new-card';

      if (this.purchasedItem && this.priceInfo) {
        if (this.isGuest) {
          if (this.hasCreateAccount) return 'create';
          return 'sign-in';
        }

        return 'purchase';
      }

      return 'upsell';
    }
  }]);
  return PurchaseModal;
}(_base.default), _class34.NewCardForm = {}, _temp17), (babelHelpers.applyDecoratedDescriptor(_class33.prototype, "doPromoCode", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class33.prototype, "doPromoCode"), _class33.prototype), babelHelpers.applyDecoratedDescriptor(_class33.prototype, "refreshPurchase", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class33.prototype, "refreshPurchase"), _class33.prototype), babelHelpers.applyDecoratedDescriptor(_class33.prototype, "selectedItem", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class33.prototype, "selectedItem"), _class33.prototype), babelHelpers.applyDecoratedDescriptor(_class33.prototype, "userLoggedIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class33.prototype, "userLoggedIn"), _class33.prototype), babelHelpers.applyDecoratedDescriptor(_class33.prototype, "onError", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class33.prototype, "onError"), _class33.prototype)), _class33);
exports.PurchaseModal = PurchaseModal;

function showNewCard() {
  return new _promisePolyfill.default(function (resolve, reject) {
    var PM = require('components/LoginForm').PurchaseModal;

    var modal = new PM(PM.NewCardForm, null, function (success) {
      if (modal.initialStateWasGuest != modal.isGuest) {
        (0, _userProfile.userProfileUpdated)();
      }

      modal.hide();
      resolve(success);
      (0, _noty.showNotificationText)('Your payment method has been added.');
    }, function (error) {
      modal.hide();
      resolve(false);
    });
    modal.show();
  });
} // showPurchase(purchasedItem, price) => Promise<boolean>


function showPurchase(upsells, selectedIndex) {
  return new _promisePolyfill.default(function (resolve, reject) {
    var modal = new (require("components/LoginForm").PurchaseModal)(upsells, selectedIndex, function (success) {
      if (modal.initialStateWasGuest != modal.isGuest) {
        (0, _userProfile.userProfileUpdated)();
      } // modal.hide();


      if (success) require("event-dispatcher").default('item-purchased');
      resolve(success);
    }, function (error) {
      modal.hide();
      resolve(false);
    });
    modal.show().then(function (element) {
      $(element).find('.modal').on('hidden.bs.modal', function (event) {
        (0, _userProfile.userProfileUpdated)();

        if (modal.initialStateWasGuest != modal.isGuest) {
          modal.hide(); // location.reload();
        }
      });
    });
  });
} // show(mode) => Promise<UserId>


function show(mode, resetInfo) {
  var r = new _promisePolyfill.default(function (resolve, reject) {
    var modal = new (require("components/LoginForm").LoginModal)(mode == 'sign-up' || mode == 'invited' ? 'create' : mode == 'reset-password' ? 'reset' : 'login', function (data) {
      if (mode == 'invited' || mode == 'reset-password') {
        resolve(Object.assign({
          modal: modal
        }, data));

        if (data && data.useCustomHome && location.href.split('?').shift() == data.defaultHome) {
          if (history.pushState) {
            history.pushState({}, "", data.useCustomHome);
          }
        }

        (0, _userProfile.userProfileUpdated)().then(function (profile) {
          if (data) {
            require("event-dispatcher").default(data.isNewAccount === true ? 'account-created' : 'signed-in', profile);
          }

          modal.hide();
        });
      } else {
        modal.waitToHide();
        resolve(Object.assign({
          modal: modal
        }, data));
      }
    }, function (error) {
      modal.hide();
      reject({
        error: error,
        modal: modal
      });
    });
    modal.resetInfo = resetInfo;
    modal.show();
  }); // We don't actually care. Make the code shut up about this.

  r.catch(function () {});
  return r;
}